import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { FormControl } from '@angular/forms';
import { connectState } from '@examdojo/angular/util';
import { MultiSelectComponent } from '@examdojo/core/select';
import { map } from 'rxjs';
import { TopicLevel3Query } from '../topic-level-3.query';

@Component({
  selector: 'dojo-topic-level-3-selector',
  template: `
    <dojo-multi-select
      [formCtrl]="formCtrl()"
      [optionLabel]="'label'"
      [optionValue]="'value'"
      [options]="state.options"
      [label]="label()"
    />
  `,
  imports: [MultiSelectComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TopicLevel3SelectorComponent {
  constructor(private readonly topicLevel3Query: TopicLevel3Query) {}

  readonly formCtrl = input.required<FormControl<number[]>>();
  readonly label = input<string>();

  readonly options$ = this.topicLevel3Query.selectAllEntities().pipe(
    map((topics) =>
      topics.map((topic) => ({
        value: topic.id,
        label: `${topic.code} - ${topic.name}`,
      })),
    ),
  );

  readonly state = connectState({
    options: this.options$,
  });
}
